// /*
//  * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
//  *
//  *This software is the confidential and proprietary information of Wells Fargo
//  *bank. ('Confidential Information'). You shall not disclose such Confidential
//  *Information and shall use it only in accordance with the terms of the license
//  *agreement you entered into with WellsFargo.
//  *
//  *Author: Ritika Khare
// */
import { useEffect } from 'react';
import fetchNuanceConfig from './fetch-nuance-config';
import { useDispatch } from 'react-redux';
import initChat from './add-nuance-frame';
import { useSelector } from 'react-redux';

var NuanceChat = function NuanceChat(_ref) {
  var routeToAuxi = _ref.routeToAuxi,
      menuClick = _ref.menuClick;
  window.NuanMessaging = window.NuanMessaging || {};
  var dispatch = useDispatch();
  var nuanceLoaded = useSelector(function (_ref2) {
    var core = _ref2.core;
    return core.nuance.nuanceCtaClicked;
  });
  var auxiWebsdkLoaded = useSelector(function (_ref3) {
    var core = _ref3.core;
    return core.nuance.auxiCtaClicked;
  });
  useEffect(function () {
    if (window.WFUI_BRIDGE && window.WFUI_BRIDGE.frameCollection.getFrame({
      uuid: window.WF_NUANCE.UUID
    })) {
      window.NuanMessaging.SDKAPI.fireCustomEvent('nuanceMenuItemClicked');
    } else {
      fetchNuanceConfig().then(function (_ref4) {
        var initChatInfo = _ref4.initChatInfo;
        initChatInfo.routeToAuxi = routeToAuxi;
        initChat(initChatInfo, menuClick, dispatch);
      });
    }
  }, [nuanceLoaded, auxiWebsdkLoaded]);
  return null;
};

export default NuanceChat;